import React from "react";

const IconTag: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
    >
      <path d="M8 11L4 7.98998L0 11V0H8V11Z" fill="#4FD1C5" />
    </svg>
  );
};

export default IconTag;
